import { FC, useState } from "react";
import { ViewProps } from "../types";
import { useBlogPostsQuery } from "@/generated";
import { BlogPostProps } from "../components/BlogPost/types";
import { useRouter } from "next/router";

export type WithDataProps = {
  posts: BlogPostProps[];
  loading: boolean;
  paginationMeta: {
    page: number | null | undefined;
    total: number | null | undefined;
    pageCount: number | null | undefined;
  };
  onNextPage: () => void;
  onPrevPage: () => void;
};

export const withData = (View: FC<WithDataProps>) => (props: ViewProps) => {
  const [page, setPage] = useState(1);
  const router = useRouter();

  const onNextPage = () => setPage((prev) => prev + 1);
  const onPrevPage = () => setPage((prev) => prev - 1);

  const { data, loading } = useBlogPostsQuery({
    variables: {
      filters: {
        ...(router?.query?.category && {
          blog_categories: {
            slug: { eq: router?.query?.category?.toString() },
          },
        }),
      },
      sort: ["publishedAt:desc"],
      pagination: {
        page,
        pageSize: 10,
      },
    },
  });

  const meta = data?.blogPosts?.meta;

  const parsedPosts = data?.blogPosts?.data?.map((post) => ({
    title: post!.attributes!.title,
    slug: post!.attributes!.slug,
    description: post?.attributes?.info_text || "",
    categories: post?.attributes?.blog_categories?.data?.map((category) => ({
      name: category?.attributes?.title,
      key: category?.attributes?.slug,
    })),
    backgroundImage: post?.attributes?.media?.data?.[0]?.attributes?.url || "",
    author: {
      image: post?.attributes?.author_image?.data?.attributes?.url || "",
      name: `${post?.attributes?.author?.data?.attributes?.firstName} ${post?.attributes?.author?.data?.attributes?.lastName}`,
    },
    dateAdded: post?.attributes?.publishedAt || "",
  })) as BlogPostProps[];

  return (
    <View
      {...props}
      posts={parsedPosts || []}
      loading={loading}
      paginationMeta={{
        page: meta?.pagination?.page,
        total: meta?.pagination?.total,
        pageCount: meta?.pagination?.pageCount,
      }}
      onNextPage={onNextPage}
      onPrevPage={onPrevPage}
    />
  );
};
